
import { z } from 'zod';

export const interviewFormSchema = z.object({
  title: z.string().min(1, "Yrkestittel er påkrevd"),
  intervieweeName: z.string().min(1, "Navn på intervjuobjekt er påkrevd"),
  company: z.string().optional(),
  context: z.string().min(1, "Kontekst er påkrevd"),
  // Allow contextUrl to be empty or a valid URL
  contextUrl: z.string().optional().refine(
    (val) => !val || val.trim() === '' || z.string().url().safeParse(val).success,
    { message: "Vennligst skriv inn en gyldig URL eller la feltet stå tomt" }
  ),
  contextImageUrl: z.string().optional(),
  contextImageCaption: z.string().optional(),
  question: z.string().min(1, "Spørsmål er påkrevd"),
  answer: z.string().min(1, "Svar er påkrevd"),
  tags: z.array(z.string()).default([]),
  photoUrl: z.string().optional(),
  timestamp: z.string().optional(),
});

export type InterviewFormValues = z.infer<typeof interviewFormSchema>;
